import PropertyImageSliderContainer from "../../../components/property/detail/PropertyImageSlider";

const PropertyImageSlider = () => {
  return <PropertyImageSliderContainer />;
};

export default PropertyImageSlider;
